class FixSize {

    constructor(_window, _document) {
        this.window = _window;
        this.document = _document
    }
        
    
    init(){

        if(this.hasBug()) {
            this.fixSections(true);
            var buttons_elements = this.document.getElementsByTagName("button");
           
            for(var l=0; l<buttons_elements.length;l++){
                
                buttons_elements[l].addEventListener("click", function () {
                    setTimeout(() => { 
                        this.fixSections(false);
                     }, 200);
                });
            }
        }
    }
    
    hasBug () {
        var outer = this.document.createElement('div');
        var inner = this.document.createElement('div');
        outer.setAttribute('style', 'display:-ms-flexbox; display:flex; min-height:100vh;');
        outer.appendChild(inner);
        (this.document.body || this.document.documentElement).appendChild(outer);

        var bug = !inner.offsetHeight;
        outer.parentNode.removeChild(outer);
    
        return bug;
    }

    fixElementHeight (el) {
        el.style.height = 'auto'; 
    
        var height = el.offsetHeight; 
        el.style.height = height + 'px'; 
    }

    fixSections(_listenner){

        var section_elements = this.document.getElementsByTagName("section");

        for(var l=0; l<section_elements.length;l++){
            var el = section_elements[l];
            
            this.fixElementHeight(el);
    
            if(_listenner){
                this.window.addEventListener('resize', function () {
                    this.fixElementHeight(el);
                });
            }
           
        }
        
    }
    
}
